import React, { Component, } from "react";
import { UserContext } from "../../../context/userContext";
import axios from "axios";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Progress,
} from "reactstrap";
import classnames from "classnames";
import * as UTILS from "../../../utils/Utils";
import CloseCrossICON from "../../../assets/images/closeCross.svg";
import VideoICON from "../../../assets/images/video.svg";
import ImageICON from "../../../assets/images/imageUpload.svg";
import ReloadICON from "../../../assets/images/reload.svg";
import CloseUpload from "../../../assets/images/closeUpload.svg";
import FileICON from "../../../assets/images/file.svg";
import { ToastContainer, toast } from "react-toastify";
import Draggable from "react-draggable"; // The default
import "./Library.scss";
import ImagesContent from "./Content/ImagesContent";
import VideosContent from "./Content/VideosContent";
import LicensedVideosContent from "./Content/LicensedVideosContent";
import FilesContent from "./Content/FilesContent";
import Axios from "../../../axios";


class Library extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.getAWSdetails = this.getAWSdetails.bind(this);
    this.state = {
      activeDrags: 0,
      deltaPosition: {
        x: 0,
        y: 0,
      },
      controlledPosition: {
        x: 0,
        y: 0,
      },
      activeTab: this.props.videoTab == true ? "1" : this.props.imageTab == true ? "2" : this.props.fileTab == true ? "3" : "1",
      statusUpload: [],
      noEncodeData: false,
      selectedFile: null,
      progressArray: [],
      loaded: [],
      dragEntered: false,
      uploadStatusFetched: false,
      uploadedSuccessfully: false,
      isMounted: false,
    };
  }
  static contextType = UserContext;
  toggle(tab) {

    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  componentDidMount = () => {
    if (this.props.clickedImageID != null) {
      this.setState({
        activeTab: "2",
      });
    } else if (this.props.fileType == "file") {
      this.setState({
        activeTab: "3",
      });
    }
    this._isMounted = true;

    this.statusUpdates();
  };
  // Drag Modal STARTS
  handleDrag = (e, ui) => {
    const { x, y } = this.state.deltaPosition;
    this.setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      },
    });
  };
  onStart = () => {
    this.setState({ activeDrags: ++this.state.activeDrags });
  };

  onStop = () => {
    this.setState({ activeDrags: --this.state.activeDrags });
  };
  // Drag Modal ENDS
  uploadStatusAPI = () => {
    const self = this;
    const userID = this.context.userID;
    const sessionID = this.context.sessionID;
    Axios.AWSService.UPLOAD_STATUS(userID, sessionID).then((response) => {
      if (this._isMounted) {
        if (response.data.body.length > 0) {
          self.setState(
            {
              statusUpload: response.data.body,
            },
            () => { }
          );
        } else if (response.data.body.length == 0) {
          self.setState({
            noEncodeData: true,
          });
        }
      }
    });
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    if (this.props.clickedImageID == null) {
      this.setState({
        activeTab: "1",
      });
    }
  };
  statusUpdates = () => {
    if (this.props.modalUpload == true && this._isMounted) {
      this.uploadStatusAPI();
    } else if (this.props.videoClicked !== null && this._isMounted) {
      this.uploadStatusAPI();
    } else if (this.props.clickedImageID !== null && this._isMounted) {
      this.uploadStatusAPI();
    }
  };
  onChangeHandler = (event) => {


    this.props.reloadAPICall(false);
    let files = event.target.files;
    let loadedArrayLocal = [];
    for (let i = 0; i < files.length; i++) {
      loadedArrayLocal.push(0);
    }

    if (
      UTILS.maxSelectFile(event) &&
      UTILS.checkMimeType(event) &&
      UTILS.checkFileSize(event)
    ) {
      //    if return true allow to setState
      this.setState(
        {
          selectedFile: files,
          loaded: loadedArrayLocal,
        },
        () => { }
      );
    }
  };
  getAWSdetails = () => {
    Object.values(this.state.selectedFile).forEach((item, index) => {
      if (
        item.type == "video/mp4" ||
        item.type == "video/avi" ||
        item.type == "video/mov" ||
        item.type == "video/x-msvideo" ||
        item.type == "video/mpeg"
      ) {

        let self = this;

        let dataIMAGE = new FormData();
        dataIMAGE.append("user_id", this.context.userID);
        dataIMAGE.append("session_id", this.context.sessionID);
        dataIMAGE.append("file", item);

        axios({
          method: "POST",
          url: import.meta.env.VITE_DEVELOPMENT_URL + "api/upload-content",
          data: dataIMAGE,
          headers: { "Content-Type": "application/json" },
          onUploadProgress: function (progressEvent) {
            let loadedArray = [...self.state.loaded];
            loadedArray[index] = self.calculateProgress(progressEvent);
            self.setState({
              loaded: loadedArray,
            });
          },
        })
          .then((res) => {
            if (res.data.status == "success") {
              const selectedFilteredFile = self.getFilteredFiles(item.name);
              self.setState(
                {
                  selectedFile: selectedFilteredFile,
                  loaded: self.removeLoadedForSelectedFile(index),
                },
                () => {
                  //debugger;
                  this.fileInput.value = "";
                  // toast.success("File is uploaded successfully!");
                  self.setState(
                    {
                      uploadedSuccessfully: true,
                    },
                    () => {
                      setTimeout(function () {
                        self.setState({
                          uploadedSuccessfully: false,
                        });
                      }, 3000);
                    }
                  );

                  this.props.reloadAPICall(true);
                }
              );
            }
          })
          .catch((error) => {
            toast.error("Upload error");
          });

        // Axios.AWSService.AWS_ACCESS().then((response) => {
        //   if (response.data.success_action_status === "201") {
        //     const data = new FormData();
        //     const success_action_status = response.data.success_action_status;
        //     const acl = response.data.acl;
        //     const key = response.data.key;
        //     const policy = response.data.Policy;
        //     const signature = response.data['X-Amz-Signature'];
        //     data.append("acl", acl);
        //     data.append("key", key);
        //     data.append("success_action_status", success_action_status);
        //     data.append("policy", policy);
        //     data.append("signature", signature);
        //     data.append("File", item);

        //     data.append('X-Amz-Credential', response.data['X-Amz-Credential']); // Must match what's in the policy
        //     data.append('X-Amz-Algorithm', response.data['X-Amz-Algorithm']);
        //     data.append('X-Amz-Date', response.data['X-Amz-Date']); // ISO timesta

        //     const headers = {
        //       "Access-Control-Allow-Origin": "*",
        //       "Process-Data": false,
        //       "Content-Type": false,
        //       "Data-Type": "xml",
        //     };

        //     let self = this;
        //     axios({
        //       method: "POST",
        //       url: import.meta.env.VITE_POST_FILE_URL,
        //       data: data,
        //       headers: headers,
        //       onUploadProgress: function (progressEvent) {
        //         let loadedArray = [...self.state.loaded];
        //         loadedArray[index] = self.calculateProgress(progressEvent);
        //         self.setState({
        //           loaded: loadedArray,
        //         });
        //       },
        //     })
        //       .then((response) => {
        //         // Do nothing

        //         if (response.status === 201) {
        //           // const selfState = this;
        //           Axios.AWSService.CONVERT(
        //             import.meta.env.VITE_PREVIEW_URL,
        //             key,

        //             this.context.userID,
        //             item.name
        //           )
        //             .then((res) => {
        //               if (res.status === 200) {
        //                 const selectedFilteredFile = self.getFilteredFiles(
        //                   item.name
        //                 );
        //                 self.setState(
        //                   {
        //                     selectedFile: selectedFilteredFile,
        //                     loaded: self.removeLoadedForSelectedFile(index),
        //                   },
        //                   () => {
        //                     this.fileInput.value = "";
        //                     // toast.success("File is uploaded successfully!");
        //                     self.setState(
        //                       {
        //                         uploadedSuccessfully: true,
        //                       },
        //                       () => {
        //                         setTimeout(function () {
        //                           self.setState({
        //                             uploadedSuccessfully: false,
        //                           });
        //                         }, 3000);
        //                       }
        //                     );

        //                     this.props.reloadAPICall(true);
        //                   }
        //                 );
        //               }
        //             })
        //             .catch((err) => {
        //               toast.error("Upload error");
        //             });
        //         }
        //       })
        //       .catch((error) => {
        //         toast.error("Upload error");
        //       });
        //   } else {
        //   }
        // });
      } else if (
        item.type == "image/png" ||
        item.type == "image/jpeg" ||
        item.type == "image/gif" ||
        item.type == "image/jpg"
      ) {
        let self = this;

        let dataIMAGE = new FormData();
        dataIMAGE.append("u", this.context.userID);
        dataIMAGE.append("sn", this.context.sessionID);
        dataIMAGE.append("file", item);

        axios({
          method: "POST",
          url: import.meta.env.VITE_DEVELOPMENT_URL + "ajax/upload-content?",
          data: dataIMAGE,
          headers: { "Content-Type": "application/json" },
          onUploadProgress: function (progressEvent) {
            let loadedArray = [...self.state.loaded];
            loadedArray[index] = self.calculateProgress(progressEvent);
            self.setState({
              loaded: loadedArray,
            });
          },
        })
          .then((res) => {
            if (res.data.status == "success") {
              const selectedFilteredFile = self.getFilteredFiles(item.name);
              self.setState(
                {
                  selectedFile: selectedFilteredFile,
                  loaded: self.removeLoadedForSelectedFile(index),
                },
                () => {
                  //debugger;
                  this.fileInput.value = "";
                  // toast.success("File is uploaded successfully!");
                  self.setState(
                    {
                      uploadedSuccessfully: true,
                    },
                    () => {
                      setTimeout(function () {
                        self.setState({
                          uploadedSuccessfully: false,
                        });
                      }, 3000);
                    }
                  );

                  this.props.reloadAPICall(true);
                }
              );
            }
          })
          .catch((error) => {
            toast.error("Upload error");
          });
      } else if (
        item.type == "audio/mp3" ||
        item.type == "application/pdf" ||
        item.type == "application/vnd.ms-powerpoint" ||
        item.type == "application/vnd.ms-excel" ||
        item.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        item.type == "application/msword" ||
        item.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {

        let self = this;

        let dataIMAGE = new FormData();
        dataIMAGE.append("user_id", this.context.userID);
        dataIMAGE.append("session_id", this.context.sessionID);
        dataIMAGE.append("file", item);

        axios({
          method: "POST",
          url: import.meta.env.VITE_DEVELOPMENT_URL + "api/upload-content",
          data: dataIMAGE,
          headers: { "Content-Type": "application/json" },
          onUploadProgress: function (progressEvent) {
            let loadedArray = [...self.state.loaded];
            loadedArray[index] = self.calculateProgress(progressEvent);
            self.setState({
              loaded: loadedArray,
            });
          },
        })
          .then((res) => {
            if (res.data.status == "success") {
              const selectedFilteredFile = self.getFilteredFiles(item.name);
              self.setState(
                {
                  selectedFile: selectedFilteredFile,
                  loaded: self.removeLoadedForSelectedFile(index),
                },
                () => {
                  //debugger;
                  this.fileInput.value = "";
                  // toast.success("File is uploaded successfully!");
                  self.setState(
                    {
                      uploadedSuccessfully: true,
                    },
                    () => {
                      setTimeout(function () {
                        self.setState({
                          uploadedSuccessfully: false,
                        });
                      }, 3000);
                    }
                  );

                  this.props.reloadAPICall(true);
                }
              );
            }
          })
          .catch((error) => {
            toast.error("Upload error");
          });
        
        // Axios.AWSService.AWS_ACCESS().then((response) => {
        //   if (response.data.success_action_status === "201") {
        //     const data = new FormData();

        //     const success_action_status = response.data.success_action_status;
        //     const acl = response.data.acl;
        //     const key = response.data.key;
        //     const policy = response.data.Policy;
        //     const signature = response.data['X-Amz-Signature'];
        //     data.append("acl", acl);
        //     data.append("key", key);
        //     data.append("success_action_status", success_action_status);
        //     data.append("policy", policy);
        //     data.append("signature", signature);
        //     data.append("file", item);

        //     data.append('X-Amz-Credential', response.data['X-Amz-Credential']); // Must match what's in the policy
        //     data.append('X-Amz-Algorithm', response.data['X-Amz-Algorithm']);
        //     data.append('X-Amz-Date', response.data['X-Amz-Date']); // ISO timesta

        //     const headers = {
        //       "Access-Control-Allow-Origin": "*",
        //       "Process-Data": false,
        //       "Content-Type": false,
        //       "Data-Type": "xml",
        //     };

        //     let self = this;
        //     axios({
        //       method: "POST",
        //       url: import.meta.env.VITE_POST_FILE_URL,
        //       data: data,
        //       headers: {
        //         "Access-Control-Allow-Origin": "*",
        //         "Process-Data": false,
        //         "Content-Type": false,
        //         "Data-Type": "xml",
        //       },
        //       onUploadProgress: function (progressEvent) {
        //         // self.setState({
        //         //   loaded: (progressEvent.loaded / progressEvent.total) * 100
        //         // });
        //         let loadedArray = [...self.state.loaded];
        //         loadedArray[index] = self.calculateProgress(progressEvent);

        //         self.setState({
        //           loaded: loadedArray,
        //         });
        //       },
        //     })
        //       .then((response) => {
        //         if (response.status === 201) {
        //           const data = new FormData();
        //           data.append("u", this.context.userID);
        //           data.append("sn", this.context.sessionID);
        //           data.append("k", key);
        //           data.append("s", item.size);
        //           data.append("fn", item.name);
        //           const headers = {
        //             "Access-Control-Allow-Origin": "*",
        //             "Process-Data": false,
        //             "Content-Type": false,
        //             "Data-Type": "json",
        //           };

        //           let self = this;
        //           axios({
        //             method: "POST",
        //             url:
        //               import.meta.env.VITE_DEVELOPMENT_URL +
        //               "ajax/upload-file-content",
        //             data: data,
        //             headers: {
        //               "Access-Control-Allow-Origin": "*",
        //               "Process-Data": false,
        //               "Content-Type": false,
        //               "Data-Type": "json",
        //             },
        //             onUploadProgress: function (progressEvent) {
        //               // self.setState({
        //               //   loaded:
        //               //     (progressEvent.loaded / progressEvent.total) * 100
        //               // });
        //               let loadedArray = [...self.state.loaded];
        //               loadedArray[index] =
        //                 self.calculateProgress(progressEvent);
        //               self.setState({
        //                 loaded: loadedArray,
        //               });
        //             },
        //           })
        //             .then((response) => {
        //               if (response.data.status === "success") {
        //                 const selectedFilteredFile = self.getFilteredFiles(
        //                   item.name
        //                 );
        //                 self.setState(
        //                   {
        //                     selectedFile: selectedFilteredFile,
        //                     loaded: self.removeLoadedForSelectedFile(index),
        //                   },
        //                   () => {
        //                     this.fileInput.value = "";
        //                     // toast.success("File is uploaded successfully!");
        //                     self.setState(
        //                       {
        //                         uploadedSuccessfully: true,
        //                       },
        //                       () => {
        //                         setTimeout(function () {
        //                           self.setState({
        //                             uploadedSuccessfully: false,
        //                           });
        //                         }, 3000);
        //                       }
        //                     );

        //                     this.props.reloadAPICall(true);
        //                   }
        //                 );
        //               }
        //             })
        //             .catch((error) => {
        //               toast.error("Upload error");
        //             });
        //         }
        //       })
        //       .catch((error) => {
        //         toast.error("Upload error");
        //       });
        //   } else {
        //   }
        // });
      }

      const self = this;
    });
  };

  calculateProgress = (progressEvent) => {
    return (progressEvent.loaded / progressEvent.total) * 100;
  };

  getFilteredFiles = (name) => {
    return Object.values(this.state.selectedFile).filter(
      (file) => file.name !== name
    );
  };
  removeLoadedForSelectedFile = (index) => {
    return this.state.loaded.filter((value, ind) => ind !== index);
  };

  deleteSelectedFile = (name, index) => {
    this.setState({
      selectedFile: false,
      loaded: this.removeLoadedForSelectedFile(index),
    });
  };
  dragEntered = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      dragEntered: !prevState.dragEntered,
    }));
  };
  dragLeave = () => {
    this.setState({
      dragEntered: false,
    });
  };
  dragOver = (e) => {
    e.preventDefault();
  };
  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ dragEntered: false }); // deactivates the drop overlay

    const files = e.dataTransfer.files; // get dropped files
    let loadedArrayLocal = [];
    for (let i = 0; i < files.length; i++) {
      loadedArrayLocal.push(0);
    }
    if (
      UTILS.maxSelectFile({ target: { files } }) &&
      UTILS.checkMimeType({ target: { files } }) &&
      UTILS.checkFileSize({ target: { files } })
    ) {
      this.setState(
        {
          selectedFile: files,
          loaded: loadedArrayLocal,
        },
      );
    }
  };
  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const progress = this.props.progress;
    let statusUploadBlock = null;
    const { deleteSelectedFile } = this;
    const loaded = this.state.loaded;
    let selectedFiles = (
      <div >
        {this.state.selectedFile !== null &&
          Object.values(this.state.selectedFile).map(function (key, index) {
            return (
              <div key={key} className="selectedFile">
                <div className="type-image">
                  {(key.type == "video/mp4" ||
                    key.type == "video/mpeg" ||
                    key.type == "video/avi" ||
                    key.type == "video/mov" ||
                    key.type == "video/x-msvideo") && <img src={VideoICON} />}

                  {(key.type == "image/jpeg" ||
                    key.type == "image/png" ||
                    key.type == "image/gif") && (
                      <img className="image" src={ImageICON} />
                    )}

                  {(key.type == "audio/mp3" ||
                    key.type == "application/pdf" ||
                    key.type == "application/vnd.ms-powerpoint" ||
                    key.type == "application/vnd.ms-excel" ||
                    key.type ==
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                    key.type == "application/msword" || key.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && <img src={FileICON} />}
                </div>
                <div className="info">
                  <p>{key.name}</p>
                  <span>{(`${key.size}` / 1048576).toFixed(2) + " MB"}</span>
                  <Progress value={loaded[index]} />
                </div>
                <button onClick={() => deleteSelectedFile(key.name, index)}>
                  <img src={CloseUpload} alt="Close" />
                </button>
              </div>
            );
          })}
      </div>
    );

    return (
      <div
        className={
          "libraryMain" +
          (this.props.modalUpload ? " my-library" : " select-video")
        }
        id={this.props.clickedImageID != null ? "imageWrapper" : null}
      >
        <div className="uploadOverlay" onClick={this.props.toggleUploadPopup} />
        <Draggable handle=".header" {...dragHandlers}>
          <div className="fileUpload--wrapper ">
            {this.props.imageTab == true ? (
              <h2 className="header">
                Select Image
                <span onClick={this.props.toggleUploadPopup}>
                  <img src={CloseCrossICON} />
                </span>
              </h2>
            ) : this.props.videoTab == true ? (
              <h2 className="header">
                Select Video
                <span onClick={this.props.toggleUploadPopup}>
                  <img src={CloseCrossICON} />
                </span>
              </h2>
            ) : this.props.fileTab == true ? (
              <h2 className="header">
                Select File
                <span onClick={this.props.toggleUploadPopup}>
                  <img src={CloseCrossICON} />
                </span>
              </h2>
            ) : (
              <h2 className="header">
                My Library
                <span onClick={this.props.toggleUploadPopup}>
                  <img src={CloseCrossICON} />
                </span>
              </h2>
            )}

            <div className="master-wrapper ">
              <div className="drop-placeholder_wrapper">
                <div
                  className={
                    "drop-placeholder " +
                    (this.state.dragEntered ? "active" : null)
                  }
                >
                  <div className="drop-content">
                    <h3>DRAG &amp; DROP</h3>

                    {this.state.selectedFile ? null : (
                      <p>
                        your files to assets, or <a href="#">browse</a>
                      </p>
                    )}
                  </div>
                  <input
                    type="file"
                    className="form-control "
                    multiple
                    onDragOver={this.dragOver}
                    onDrop={this.handleDrop}
                    onDragEnter={this.dragEntered}
                    onDragLeave={this.dragLeave}
                    onChange={this.onChangeHandler}
                    ref={(ref) => (this.fileInput = ref)}
                  />
                </div>
                {this.state.selectedFile ? (
                  <div className="selectedFileWrapper">
                    {/* <Progress value={this.state.loaded} /> */}

                    {selectedFiles}
                  </div>
                ) : null}
                {this.state.uploadedSuccessfully ? (
                  <div className="wrapperSaved uploadedSuccessfully">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 98.5 98.5"
                      enableBackground="new 0 0 98.5 98.5"
                    >
                      <path
                        className="checkmark"
                        fill="none"
                        strokeWidth="8"
                        strokeMiterlimit="10"
                        d="M81.7,17.8C73.5,9.3,62,4,49.2,4
C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                      />
                    </svg>
                    Your content is uploaded successfully.
                  </div>
                ) : null}
                {this.state.selectedFile &&
                  this.state.selectedFile.length > 0 ? (
                  <button
                    type="button"
                    className="btn btn-success btn-block"
                    onClick={this.getAWSdetails}
                  >
                    Upload
                  </button>
                ) : null}

              </div>

              <div className="libraryContent selectVideo">
                {this.props.selectingContent ? (
                  <Nav
                    tabs
                    className={"nav-tabs" + this.props.fileType == "file" ? "hidden" : " "}

                  >
                    {this.props.videoTab == true ? (
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "1",
                          })}
                          onClick={() => {
                            this.toggle("1");
                          }}
                        >
                          Videos
                        </NavLink>
                      </NavItem>
                    ) : null}

                    {this.props.videoTab == true ? (
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "4",
                          })}
                          onClick={() => {
                            this.toggle("4");
                          }}
                        >
                          Licensed Videos
                        </NavLink>
                      </NavItem>
                    ) : (
                      ""
                    )}
                  </Nav>
                ) : (
                  <Nav
                    tabs
                    className={this.props.fileType == "file" ? "hidden" : " "}
                  >

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggle("1");
                        }}
                      >
                        Videos
                      </NavLink>
                    </NavItem>


                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggle("2");
                        }}
                      >
                        Images
                      </NavLink>
                    </NavItem>


                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "3",
                        })}
                        onClick={() => {
                          this.toggle("3");
                        }}
                      >
                        Files
                      </NavLink>
                    </NavItem>


                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "4",
                        })}
                        onClick={() => {
                          this.toggle("4");
                        }}
                      >
                        Licensed Videos
                      </NavLink>
                    </NavItem>

                  </Nav>
                )}

                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">


                    <VideosContent
                      selectingContent={this.props.selectingContent}
                      closeModal={this.props.toggleUploadPopup}
                      userID={this.context.userID}
                      sessionID={this.context.sessionID}
                      videoClicked={this.props.videoClicked}
                      resetURL={this.props.resetURL}
                      videoDataID={this.props.videoDataID}
                      modalUpload={this.props.modalUpload}
                      ID={this.props.ID}
                      initP={this.props.initP}
                      noMoreRecords={false}
                    />


                  </TabPane>
                  <TabPane tabId="2">


                    <ImagesContent
                      selectingContent={this.props.selectingContent}
                      userID={this.context.userID}
                      sessionID={this.context.sessionID}
                      modalUpload={this.props.modalUpload}
                      ID={this.props.ID}
                      initP={this.props.initP}
                      addImage={this.props.addImage}
                      closeImageLibrary={this.props.toggleUploadPopup}
                      opacity={this.props.opacity}
                      radius={this.props.radius}
                      float={this.props.float}
                    />


                  </TabPane>
                  <TabPane tabId="3">


                    <FilesContent
                      pushFiles={this.props.pushFiles}
                      userID={this.context.userID}
                      sessionID={this.context.sessionID}
                      videoClicked={this.props.videoClicked}
                      videoDataID={this.props.videoDataID}
                      modalUpload={this.props.modalUpload}
                      files={this.props.files}
                      srcID={this.props.srcID}
                      ID={this.props.ID}
                      toggleUploadPopup={this.props.toggleUploadPopup}
                      initP={this.props.initP}
                      addImage={this.props.addImage}
                      closeImageLibrary={this.props.closeImageLibrary}
                      fileType={this.props.fileType}
                      selectingContent={this.props.selectingContent}
                      opacity={this.props.opacity}
                      radius={this.props.radius}
                      float={this.props.float}
                    />


                  </TabPane>
                  <TabPane tabId="4">

                    <LicensedVideosContent
                      selectingContent={this.props.selectingContent}
                      closeModal={this.props.toggleUploadPopup}
                      userID={this.context.userID}
                      sessionID={this.context.sessionID}
                      videoClicked={this.props.videoClicked}
                      resetURL={this.props.resetURL}
                      videoDataID={this.props.videoDataID}
                      modalUpload={this.props.modalUpload}
                      ID={this.props.ID}
                      initP={this.props.initP}
                      noMoreRecords={false}
                    />


                  </TabPane>
                </TabContent>
              </div>

              <div className="clear" />
              <div className="form-group">
                <ToastContainer position="top-center" autoClose={5000} />
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reloadAPI: state.present.reloadAPI,
    layoutTitle: state.present.layoutTitle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reloadAPICall: (api) => dispatch(actionTypes.reload_api(api)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Library);
